import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { updateHubFilteredVessels, updatePermission } from "../../actions/Users/authenticate";
import { useEffect, useLayoutEffect, useState } from "react";
import { HUB_RESOURCE_FIELD_VESSELNAME, SIDE_MENU_ITEM_HUB } from "../../utils/constants";
import CommonFilters from "../../components/BreadCrumbs/CommonFilters";
import { SERVICE_FUNCTION_TO_FEATURE } from "../../config";
import HubDetailsTable from "./HubDetailsTable";
import './hubDetails.css';
import { checkLoggedInUserAuthorizedToViewPage, getDecodeURI, getEncodedURI, strToK4HubList, strToK4IdList, updateTimePeriod } from "../../utils/util";
import { getHubDataSitesList } from "../../actions/Users/authenticateHub";
import { CONST_ALL_VESSELS } from "../../constants/Constants";
import _ from "lodash";
import AgentTable from "./AgentTable";
import AgentConfigTable from "../Hub4Details/AgentConfig";
import TabsComponent from "../../components/NewTabs";
import HubEvent from "./HubEvent/HubEvent";
import '../HubDetails/AgentConfig/AgentConfig.css';

const HubDetails = (props) => {
    const { authReducer, setHubDataLoading, setHubDataCountLoading, setHubDataClientTableLoading, updatePermission, getHubDataSitesList, location,  history, updateHubFilteredVessels, setHubDashboardClientWiseLoading, setHhubDashboardClientWiseCountLoading, setHubDashboardCarrierClientTableLoading, setHubDashboardCarrierServiceTableLoading, setTopologyHubTableLoading, uploadAgentConfigLoading } = props;
    let _q: any = getDecodeURI(location.search);
    const [loading, setLoading] = useState('');

    const [activeTab, setActiveTab] = useState(_q.hasOwnProperty('tab') ? _q.tab : 'hub');
    const dispatch = useDispatch();

    const VIEW_VESSEL_SUMMARY = "view-vessel-summary";

    const viewVesselSummaryService = SERVICE_FUNCTION_TO_FEATURE[VIEW_VESSEL_SUMMARY]["service"];
    const viewVesselSummaryFunction = SERVICE_FUNCTION_TO_FEATURE[VIEW_VESSEL_SUMMARY]["function"];

    if (authReducer && (!authReducer.sideMenu || SIDE_MENU_ITEM_HUB !== authReducer.sideMenu.menuItem)) {
        authReducer.sideMenu = { menuItem: SIDE_MENU_ITEM_HUB };
    }

    useLayoutEffect(() => {
        let authorized = checkLoggedInUserAuthorizedToViewPage(viewVesselSummaryService, viewVesselSummaryFunction);
        if (authorized && !authReducer.permission) {
            const info = {
                permission: {
                    service: viewVesselSummaryService,
                    serviceFunction: viewVesselSummaryFunction,
                },
                isMultiVessel: false,
                isSingleVessel: false,
                showOu: true,
                ou: authReducer.selectedOu ? authReducer.selectedOu : '',
                hubSites: activeTab == 'hub' ? true : false
            };
            updatePermission(info);
        }
    }, [activeTab])

    useEffect(() => {
        setLoading(setHubDataLoading || setHubDataCountLoading || setHubDataClientTableLoading || setHubDashboardClientWiseLoading || setHhubDashboardClientWiseCountLoading ||
            setHubDashboardCarrierClientTableLoading || setHubDashboardCarrierServiceTableLoading || setTopologyHubTableLoading || authReducer?.getAgentHubEventsLoading || authReducer?.getAgentHubEventFiltersLoading || authReducer?.getAgentsLoading || uploadAgentConfigLoading)
    }, [setHubDataLoading , setHubDataCountLoading, setHubDataClientTableLoading, setHubDashboardClientWiseLoading, setHhubDashboardClientWiseCountLoading,
        setHubDashboardCarrierClientTableLoading, setHubDashboardCarrierServiceTableLoading, setTopologyHubTableLoading, authReducer?.getAgentHubEventsLoading, authReducer?.getAgentHubEventFiltersLoading, authReducer?.getAgentsLoading, uploadAgentConfigLoading])

    const tabs = [
        { tabName: 'Hub', tabValue: 'hub', pathName: '/hub' },
        { tabName: 'Agent', tabValue: 'agent', pathName: '/hub' },
        { tabName: 'Agent Config', tabValue: 'agentConfig', pathName: '/hub', hideTab: localStorage?.getItem("pacHubEnabled") === "true" ? 'No' : 'Yes' },
        { tabName: 'Events', tabValue: 'events', pathName: '/hub', hideTab: localStorage?.getItem("pacHubEnabled") === "true" ? 'No' : 'Yes' }
    ]

    const doNavigateTab = (pathname, tabName) => {
        const currentParams = getDecodeURI(location?.search);
        const params:any = {};
        if (currentParams.ouName) {
          params['ouName'] = currentParams.ouName;
        }
        if (currentParams.ouId) {
          params['ouId'] = currentParams.ouId;
        }
        if (currentParams.k4Ids) {
          params['hubK4Ids'] = currentParams.k4Ids;
        }
        if(currentParams.sideNav){
          params['sideNav'] = currentParams.sideNav
        }
        if(currentParams.interval) {
          params['interval'] = currentParams.interval
        }
        const { startDate, endDate } = updateTimePeriod(dispatch, location);
        params.startDate = startDate;
        params.endDate = endDate;
        params.tab = tabName;
        history.push({ pathname, search: getEncodedURI(params) });
        setActiveTab(tabName);
      }

    return (
        <div>
            <CommonFilters loading={loading} showWantType={false} showSummaryPeriod={activeTab === 'agentConfig' ? false : true} userGuide={[true, 'hub1']}></CommonFilters>
            <TabsComponent tabs={tabs} handleChangeTab={doNavigateTab} activeTab={activeTab} />
            <div className="hub_details_container">
                <div>
                {activeTab === 'hub' 
                    ? <HubDetailsTable /> : activeTab === 'agent' 
                    ? <AgentTable/> : activeTab === 'agentConfig'  && localStorage.getItem("pacHubEnabled") === "true"
                    ? <AgentConfigTable/> : activeTab === 'events'  && localStorage.getItem("pacHubEnabled") === "true" 
                    ? <HubEvent /> : null
                }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    setHubDataLoading: state.authReducer.setHubDataLoading,
    setHubDataCountLoading: state.authReducer.setHubDataCountLoading,
    setHubDataClientTableLoading: state.authReducer.setHubDataClientTableLoading,
    setHubDashboardClientWiseLoading: state.authReducer.setHubDashboardClientWiseLoading,
    setHubDashboardClientWiseCountLoading: state.authReducer.setHubDashboardClientWiseCountLoading,
    setHubDashboardCarrierClientTableLoading: state.authReducer.setHubDashboardCarrierClientTableLoading,
    setHubDashboardCarrierServiceTableLoading: state.authReducer.setHubDashboardCarrierServiceTableLoading,
    setTopologyHubTableLoading: state.authReducer.setTopologyHubTableLoading,
    uploadAgentConfigLoading: state.authReducer.uploadAgentConfigLoading,
});

export default withRouter(
    connect(mapStateToProps, {updatePermission, getHubDataSitesList, updateHubFilteredVessels})(HubDetails)
)